import React, { useEffect, useState, useCallback } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import AddIcon from '@mui/icons-material/Add'

import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import CreateEvent from './CreateEvent'
import AddContact from './AddContact'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 2,
  pb: 2,
}

export default function AddCheckList({ setCheckListIds }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const [showContactModel, setShowContactModel] = useState(false)
  const [checked, setChecked] = useState([])
  const [contacts, setContacts] = useState([])
  const [event, setEvent] = useState([])
  const [checkList, setCheckList] = useState([])

  // useEffect(() => {
  //   fetchCeckList()
  // }, [])
  const fetchCeckList = async () => {
    const url = urls.getAllCheckList + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        if (!v.TaskId) filterTypes.push({ label: `${v.NomTask}`, id: v.id })
      })
      setCheckList([...filterTypes])
    }
  }
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]
    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    setChecked(newChecked)
  }
  const [showModal, setShowModal] = useState(false)
  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  })
  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      NomTask: '',
    },
  })
  const handleOpen = () => {
    // fetchCeckList()

    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    setChecked([])
    setContacts([])
    setEvent([])
    reset()
  }
  const addCheckList = async () => {
    setCheckListIds(checked)
    handleClose()
  }
  const onSubmit = async () => {
    let payload = {}
    payload = {
      NomTask: getValues('NomTask'),
      Contacts: contacts,
      EventData: event,
    }
    const response = await makePostRequest(urls.checkListOperations, payload, {}, true)
    if (response.status === 201) {
      // fetchCeckList()
      setCheckListIds(response.data.id)
      setChecked([])
      setContacts([])
      setEvent([])
      reset()
      setValue('NomTask', '')
      handleClose()
    }
  }

  return (
    <>
      <Button onClick={handleOpen}>{t('mesToDo.addTask')}</Button>
      <Modal open={open}>
        <Box sx={{ ...style }}>
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '9999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    Checklist pour 'task.nom'
                  </Typography>
                  <Box>
                    {/* <Box onSubmit={handleSubmit(onSubmit)}> */}
                    <DialogContent>
                      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                        {checkList.map((value) => {
                          const labelId = `checkbox-list-label-${value.id}`
                          return (
                            <ListItem key={value.id} disablePadding>
                              <ListItemButton
                                role={undefined}
                                onClick={handleToggle(value.id)}
                                dense
                              >
                                <ListItemIcon sx={{ minWidth: '0' }}>
                                  <Checkbox
                                    edge="start"
                                    checked={checked.indexOf(value.id) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                  />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={`${value.label}`} />
                              </ListItemButton>
                            </ListItem>
                          )
                        })}
                      </List>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '-webkit-fill-available',
                        }}
                      >
                        <Box sx={{ width: '-webkit-fill-available' }}>
                          <Input
                            control={control}
                            inputProps={{
                              variant: 'outlined',
                              required: true,
                              size: 'small',
                              type: 'text',
                            }}
                            rules={{ required: true }}
                            name="NomTask"
                            label={t('mesToDo.addItem')}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '0',
                            '& button': { minWidth: '0', color: '#434343', padding: '0' },
                          }}
                        >
                          <Button
                            onClick={() => {
                              toggleModal()
                            }}
                          >
                            <CalendarMonthIcon />
                          </Button>
                          <Button onClick={() => setShowContactModel(true)}>
                            <PersonAddAlt1Icon />
                          </Button>
                          {/* <Button onClick={onSubmit}>
                            <AddIcon />
                          </Button> */}
                        </Box>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => onSubmit()}>{t('mesToDo.validate')}</Button>
                      {/* <Button onClick={() => addCheckList()}>Valider</Button> */}
                    </DialogActions>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {showModal && (
        <CreateEvent isOpen={showModal} toggleModal={toggleModal} setEvent={setEvent} />
      )}
      {showContactModel && (
        <AddContact checkListContacts={setContacts} setShowContactModel={setShowContactModel} />
      )}
    </>
  )
}
